import React from "react";

export default function MySQL_BINARY() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">MySQL_BINARY</h1>
      <p>This is the MySQL_BINARY component generated from the SQL JSON.</p>
    </div>
  );
}
